<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">设置</span>
    </h2>
    <breadcrumb firstName="门店管理"></breadcrumb>
    <el-card class="setting-shop-wrapper">
      <section class="audit-setting">
        <div class="title">药店审方模式</div>
        <controller label="线下审方" v-model="offlineMode" />
        <div class="tips">启用后，医生开具处方后即可下载打印处方笺，药师在线下签字审方</div>
      </section>
      <section class="channel-setting" v-if="form.channelAuditMode.length > 0">
        <div class="title">渠道独立设置审方模式</div>
        <div class="tips">支持三方渠道独立设定审方模式，不影响使用智云问诊产品开方的审方模式</div>
        <el-form :model="form" ref="ruleForm" label-position="left" label-width="80px" class="isPlatform_class">
          <template v-for="(item, index) in form.channelAuditMode">
            <div class="box" :key="index">
              <el-form-item :label="item.channelName">
                <el-radio-group v-model="item.isPlatform">
                  <el-radio :label="1">智云平台药师</el-radio>
                  <el-radio :label="2">线下审方</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </section>
      <el-button class="submit" type="primary" @click="confirmSetting">保存</el-button>
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import breadcrumb from '@/components/global/breadcrumb';
import controller from './components/controller.vue';

export default {
  name: 'settingShop',
  components: {
    breadcrumb,
    controller
  },
  data() {
    return {
      originMode: {},
      offlineMode: 0,
      form: {
        channelAuditMode: []
      }
    };
  },
  mounted() {
    this.getStoreAuditModeSetting();
  },
  methods: {
    getStoreAuditModeSetting() {
      const { storeId } = this.$route.params;
      Fetch.getStoreAuditModeSetting({ storeId }).then(({ offlineMode, channelAuditMode }) => {
        this.offlineMode = offlineMode;

        this.originMode = { offlineMode, channelAuditMode: JSON.parse(JSON.stringify(channelAuditMode)) };
        this.form.channelAuditMode = channelAuditMode;
      });
    },

    confirmSetting() {
      this.$confirm('确认保存当前设置', '确认保存', {
        customClass: 'confirm',
        center: true,
        showClose: false
      }).then(() => {
        const { originMode, offlineMode } = this;

        const { storeId } = this.$route.params;
        const data = { storeId, originMode, newMode: { offlineMode, channelAuditMode: this.form.channelAuditMode } };

        return Fetch.updateStoreAuditModeSetting({
          ...data
        }).then(() => {
          this.$message.success('保存成功');
          this.$router.push('/shopManagement');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
}
.setting-shop-wrapper {
  .audit-setting {
    margin-bottom: 32px;
  }

  .channel-setting {
    margin-bottom: 20px;
  }

  .title {
    margin-bottom: 12px;
    color: #242424;
    font-size: 18px;
    font-weight: bold;
  }

  .controller {
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 8px;

    /deep/.label {
      width: 80px;
      color: #707070;
      font-size: 14px;
    }

    /deep/.content {
      flex: 1;
      font-size: 14px;
    }

    /deep/.el-radio {
      color: #bdbdbd;
    }
  }
  .isPlatform_class {
    @extend .controller;
    display: block;
    height: auto;
  }

  .tips {
    margin-bottom: 12px;
    font-size: 12px;
    color: #707070;

    &:before {
      content: '*';
      color: #e0514c;
      font-size: 12px;
    }
  }

  .submit {
    margin-left: 80px;
    width: 174px;
  }
}
</style>
